import { render, staticRenderFns } from "./EmailSettingsWrapper.vue?vue&type=template&id=3ace992c&lang=pug&"
import script from "./EmailSettingsWrapper.vue?vue&type=script&lang=js&"
export * from "./EmailSettingsWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports